// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5734831b","453":"694dc84b","732":"9b974037","977":"a368f140"}[chunkId] + ".chunk.js";
};